import React from "react";
import { Bar } from "react-chartjs-2";
import { getGraphTitleFromGraphOptions } from "../Utils";

function getAverage(graphData) {
    const sumPerDay = getSumPerDay(graphData);
    const avg = sumPerDay.reduce((sum, item) => sum + item.value + item.value2, 0) / sumPerDay.length;
    return avg;
}

function getSumPerDay(graphData) {
    return graphData.data.reduce((accumulator, current) => {
        // Check if there's already an entry for the current tag (date)
        const existing = accumulator.find(item => item.tag === current.tag);

        if (existing) {
            // If entry exists, accumulate the value fields
            existing.value += current.value || 0;
            existing.value2 += current.value2 || 0;
        } else {
            // If entry does not exist, add a new one
            accumulator.push({
                tag: current.tag,
                value: current.value || 0,
                value2: current.value2 || 0,
                category: 'All' // or any category you might want to use for grouped entries
            });
        }

        return accumulator;
    }, []);
}

function getUniqueTagsFromGraphData(graphData) {
    const tags = graphData.data.map(row => row.tag);
    return tags.filter((value, idx) => tags.indexOf(value) === idx);
}

function getUniqueCategoriesFromGraphData(graphData) {
    const categories = graphData.data.map(row => row.category);
    return categories.filter((value, idx) => categories.indexOf(value) === idx);
}

function getDatasetsFromGraphData(graphData) {
    // Organizada la información por categoría
    let datasets = [];
    let uniqueCategories = getUniqueCategoriesFromGraphData(graphData);

    for(const category of uniqueCategories) {
        let data = []
        const dateSet = new Set();
        for(const row of graphData.data) {
        if(dateSet.has(row.tag)) {
            if(row.category === category) { // Sobreescribir el 0 que hemos puesto anteriormente
                data[data.length-1] = row.value
            }
        } else {
            if(row.category === category) {
                data.push(row.value)
            } else {
                data.push(0.0)
            }
            dateSet.add(row.tag)
        }
        
        }
        const dataset = {
        label: category,
        data: data
        }
        datasets.push(dataset);
    }
    return datasets;
}

export default function StackedBarChart({ graphData, desiredGraphOptions }) {
    const data = {
        labels: getUniqueTagsFromGraphData(graphData),
        datasets: getDatasetsFromGraphData(graphData)
    }

    const avg_annotation = {
        type: 'line',
        borderColor: 'black',
        borderDash: [6, 6],
        borderDashOffset: 0,
        borderWidth: 2,
        label: {
            display: true,
            content: 'Average: ' + getAverage(graphData).toFixed(2),
            position: 'end'
        },
        scaleID: 'y',
        value: getAverage(graphData)
    }

    const options = {
        animation: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                enabled: true
            },
            title: {
                display: true,
                text: getGraphTitleFromGraphOptions(desiredGraphOptions)
            },
            annotation: {
                annotations: {
                    avg_annotation
                }
            }
        },
        scales: {
            x: {
                stacked: true
            },
            y: {
                stacked: true
            }
        }
    }

    return <Bar options={options} data={data} />;
}